import { EditTabsPattern } from '@/components'
import ConfirmDialogContextProvider from '@/components/ConfirmDialogContext'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import RecipeEditor, { ComponentEditorProps } from './CodeEditor'
import ConfigData, { ConfigDataProps } from './Config'
import History from './History'
import SettingsTab, { SettingsTabProps } from './Settings'

export type CustomComponentProps = SettingsTabProps &
  ComponentEditorProps &
  ConfigDataProps

export function CustomComponent({
  label,
  type,
  schemaVersion,
  schemaName,
  generateSchema,
  parseConfig,
}: CustomComponentProps) {
  const { componentID, useUrl } = useComponentProvider()

  const tabs = [
    {
      component: <SettingsTab label={label} type={type} />,
      name: 'settings',
    },
    {
      component: (
        <RecipeEditor
          generateSchema={generateSchema}
          schemaName={schemaName}
          schemaVersion={schemaVersion}
        />
      ),
      name: 'code-editor',
    },
    { component: <History />, name: 'version' },
    {
      component: <ConfigData label={label} parseConfig={parseConfig} />,
      name: 'config',
    },
  ]
  return (
    <ConfirmDialogContextProvider>
      <EditTabsPattern
        defaultTab="settings"
        showTabs={!!componentID}
        tabs={tabs}
        urlParams={useUrl}
      />
    </ConfirmDialogContextProvider>
  )
}
